import type { WorkbookSinkTargetRef } from '@erp/shared-types';
import { skipToken, useMutation, useQuery } from '@tanstack/react-query';
import { orpc } from '@/api/rpc/client';

/** The tables a Data sink can write: Data Source Link and Stateful tables. */
export function useWorkbookSinkTargets() {
  return useQuery(
    orpc.workbooks.sinkTargets.queryOptions({ input: {}, staleTime: 60_000 }),
  );
}

/** The columns of a target's table, read once a target is chosen. */
export function useWorkbookSinkTargetColumns(
  ref: WorkbookSinkTargetRef | undefined,
) {
  return useQuery(
    orpc.workbooks.sinkTargetColumns.queryOptions({
      input: ref ?? skipToken,
      staleTime: 60_000,
    }),
  );
}

/** Writes a saved Data sink's rows now. */
export function useDeliverWorkbookSink() {
  return useMutation(orpc.workbooks.deliverSink.mutationOptions());
}
